var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-5xl m-auto"},[_c('orders-details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }